Number.prototype.withVat = function (percentage: number) {
  if (!this.valueOf()) return 0;
  return +(this.valueOf() + (this.valueOf() * percentage) / 100).toFixed(2);
};

Number.prototype.vatAmount = function (percentage: number) {
  if (!this.valueOf()) return 0;
  return +(this.valueOf() * (percentage / 100)).toFixed(2);
};
